// import $ from "jquery";
import ajaxSubmit from "jquery-form";
import ajaxForm from "jquery-form";

import baseClass from "./base";
import generalTools from "./tools";

import toolsBootstrap from "./toolsBootstrap";

var CUSTOMFORMVAR = function () {
  this.currentformid = "";

  // ============================================================================
  this.afterSuccesFormSubmit = function (res, status, xhr) {
    customFormObj.currentformid = "";
    baseClass.processAjaxResultSuccessProcessCommands("", res, status, xhr);
    baseClass.OnReadyAll();
    baseClass.HideIsLoadingInProgress();
  };

  // ============================================================================
  this.afterErrorFormSubmit = function (res, status, xhr) {
    customFormObj.currentformid = "";
    baseClass.HideIsLoadingInProgress();
  };

  // ============================================================================
  this.manuallyBeforeFormSubmit = function (obj) {
    try {
      // CKEDITOR - updateElement
      //	for(var i in CKEDITOR.instances)
      //	{
      //		CKEDITOR.instances[i].updateElement();
      //	}
      obj.find('[class*="jsCkeditor"]').each(function () {
        var id = $(this).attr("id");
        var instance = CKEDITOR.instances[id];
        if (instance) {
          CKEDITOR.instances[id].updateElement();
        }
      });

    } catch (e) {
      console.log(e);
    }

    // -----------------------
    var hascutomcheckbox = obj.attr("hascutomcheckbox");
    var customcheckboxobjects = obj.attr("customcheckboxobjects");
    var cutomcheckboxname = obj.attr("cutomcheckboxname");

    if (hascutomcheckbox == "1") {
      $(customcheckboxobjects + ":checked").each(function () {
        obj.append(
          '<input type="hidden" name="' +
            cutomcheckboxname +
            '" value="' +
            $(this).val() +
            '" /> '
        );
      });
    }
    // -----------------------
  };

  // ============================================================================
};

var customFormObj = new CUSTOMFORMVAR();

baseClass.OnReadyArrAdd(function () {

  $(".js_af")
    .on('submit', function () {
      var fid = $(this).attr("id");
      if (customFormObj.currentformid == fid) return false;

      customFormObj.currentformid = fid;
      var valfunc = $(this).attr("data-valfunc");
      var aftfunc = $(this).attr("data-aftfunc");
      if (valfunc) if (!eval(valfunc)) return false;
      var loadind = $(this).attr("data-loadind");
      var targetid = $(this).attr("data-targetid");
      if (!targetid) targetid = "main";
      if (loadind == undefined) {
        baseClass.ShowIsLoadingInProgress();
      } else {
        if (loadind == "mini") baseClass.putloadinindicator(targetid);
      }

      var href = $(this).attr("action");
      var varResetForm = $(this).attr("data-resetForm");
      if (varResetForm) varResetForm = true;
      else varResetForm = false;
      
      if (href.indexOf("?") >= 0) href += "&rt=ajax";
      else href += "?rt=ajax";

      href = href.replace("/?", "?");
      var lastChar = href[href.length - 1];
      if (lastChar == "/") {
        href = href.substring(0, href.length - 1);
      }

      // console.log(href);
      // console.log(targetid);

      // $(this).attr("action", href);
      var method = $(this).attr("method");
      method = (method == undefined) ? "POST" : method;

      var enctype = $(this).attr("enctype");
      enctype = enctype == undefined ? "multipart/form-data" : enctype;

      $(this).attr("method", method);
      $(this).attr("enctype", enctype);

      customFormObj.manuallyBeforeFormSubmit($(this));

      var options = {
        url: href,
        type: method,
        target: "#" + targetid,
        beforeSubmit: customFormObj.beforeFormSubmit,
        success: customFormObj.afterSuccesFormSubmit,
        error: customFormObj.afterErrorFormSubmit,
        resetForm: varResetForm,
      };

      if ($(this).attr("data-closedialog") != undefined) {
        toolsBootstrap.bsCloseDialog($(this));
      }


      $(this).ajaxSubmit(options);

      return false;
    })
  ;


 $(".js_af").each(function () {
    if ($(this).hasClass("true_js_af")) return;
    var obj = $(this);
   obj.addClass("true_js_af");
   
    var currentformid = $(this).attr("id");
    if (currentformid == undefined)
    {
      currentformid = generalTools.uuidv4();
      obj.attr('id', currentformid);
    }

    var method = $(this).attr("method");
    if (method == undefined) {
      method = 'POST';
      obj.attr("method", method);
    }

   ajaxForm($(this));

  });
});
